<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <div class="container">
        <div class="area_wrap">
          <div class="imgWrap">
            <img src="@/assets/images/thanq_logo1.svg" />
          </div>
          <div class="explain_title">
            <span>서울이비인후과는</span>
            <span>?</span>
          </div>

          <div class="explain_content">
            <!-- <p>갑상선암-두경부암 진단과 수술에 특화된 병원입니다.</p>
            <p>단순 감기나 귀 질환, 코 질환 진료는 하지 않습니다.</p>
            <p>본원 의료진(원장)들은 모두 대학병원 교수 출신의 전문의로, </p>
            <p>전문 분야가 조금씩 다릅니다.</p>
            <p>내원 사유를 클릭하시면 해당 분야에 가장 전문적인</p>
            <p>의료진을 추천해 드립니다.</p>
            <p>외래 진료 (검사나 수술 상담) 후 수술할 의사를 변경하고자</p>
            <p>할 경우에는 나중에 변경할 수 있습니다.</p> -->
            <p>
              땡큐서울의원으로 전화(1522-8775)하셔서 예약하시거나, 네이버예약을
              통해 예약을 하시기 바랍니다
            </p>
            <div class="smallBtnWrap">
              <button onclick="location.href='tel:15228775'">
                <img src="@/assets/images/call_white.svg" />전화걸기
              </button>
            </div>
            <div class="text_wrap red">
              <h2>1522-8775</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <!-- <router-link to="/reservation/selectDisease"> -->
        <router-link to="/">
          <button type="button" class="callTerms">확인</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      transDate: {
        headerName: "예약",
        prevUrl: "/",
      },
      resvFlag: "",
      setCount: false,
    };
  },
  computed: {
    ...mapGetters([]),
    ...mapState(["checkPopup"]),
  },
  created() {
    if (history.pushState !== undefined) {
      history.pushState({}, "", location.href);
      window.onpopstate = () => {
        this.callPrev();
      };
    }
  },
  methods: {
    ...mapActions([]),
    callPrev() {
      if (this.setCount) {
        this.$router.push("/");
      } else {
        history.go(1);
      }
      this.setCount = true;
      // 클로즈 함수 구현
    },
  },
  components: {
    AppHeader,
    AppSidebar,
  },
  beforeDestroy() {
    this.setCount = false;
  },
};
</script>

<style lang="scss" scoped>
.explain_content {
  p {
    font-size: 18px;
  }
}
.smallBtnWrap {
  width: 100%;
  padding: 20px 0 5px;
  display: flex;
  justify-content: center;

  button {
    border: 0;
    padding: 4px 13px;
    background: #ff6565;
    border-radius: 5px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    color: #fff;
    font-family: "NotoSansCJKkr", serif;
    font-size: 1.25rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 145px;

    img {
      padding-right: 5px;
    }
  }
}
.text_wrap {
  padding: 0;
  text-align: center;
  &.red {
    font-size: 1.25rem;
    line-height: 1.45;
    color: #ff6565;
  }
}
</style>
